export default __webpack_public_path__ + "static/media/undraw_reading.32b2b7ac.svg";